<template>
  <div
    ref="tool"
    class="tool mwe-area"
    :style="{
      ...texteditor.toolbar.position,
    }"
  >
    <b-card 
      header-class="p-0"
      header-bg-variant="white"
      body-class="p-0"
      bg-bg-variant="white"
      footer-class="px-gd-3 py-gd-2"
      footer-bg-variant="white"
      style="width: 280px"
    >
      <template #header>
        <div 
          ref="toolheader"
          class="px-gd-3 py-gd-2 cursor-move"
          v-on:mousedown="dragMouseDown"
        >
          <div class="row align-items-center -mx-gd-half">
            <div class="col px-gd-half flh-1"><TitleModal class="text-paragraph" :label="$t('engine.manageText.modalWidget.lblText', languageEngine)"/></div>
            <div class="col-auto px-gd-half flh-1">
              <span class="text-paragraph cursor-pointer" @click="$emit('close')"><i class="far fa-times fs-20"></i></span>
            </div>
          </div>
        </div>
      </template>
      
      <template>
        <!-- <pre style='font-size: 10px;'>selection = {{ selection }}</pre> -->
        <!-- <pre style='font-size: 10px;'>texteditor.templateFormats.heading1 = {{ texteditor.templateFormats.heading1 }}</pre> -->
        <!-- <pre style='font-size: 10px;'>selectionFormatTemplate = {{ selectionFormatTemplate }}</pre> -->
        <!-- <pre style='font-size: 10px;'>selectionFormat = {{ selectionFormat }}</pre> -->
        <!-- <pre style='font-size: 10px;'>selectionFormatMerge = {{ selectionFormatMerge }}</pre> -->
        <!-- <pre style='font-size: 10px;'>customFormats = {{ customFormats }}</pre> -->
        <div class="px-gd-3 py-gd-2" v-if="
          tools.includes('heading') ||
          tools.includes('family') ||
          tools.includes('size') ||
          tools.includes('lineHeight')
        ">
          <div class="row">
            <div class="col-12 mt-gd-1-nfc" v-if="tools.includes('heading')"><ToolTemplate /></div>
            <div class="col-12 mt-gd-1-nfc" v-if="tools.includes('family')"><ToolFamily /></div>
            <div class="col-12 mt-gd-1-nfc" v-if="tools.includes('size')"><ToolSize :value="selectionFormatMerge.size" /></div>
            <div class="col-12 mt-gd-1-nfc" v-if="tools.includes('lineHeight')"><ToolLineHeight :value="selectionFormatMerge.lineHeight" /></div>
          </div>
        </div>
        <div class="px-gd-2 py-gd-2 border-top" v-if="
          tools.includes('bold') ||
          tools.includes('italic') ||
          tools.includes('underline') ||
          tools.includes('color') ||
          tools.includes('backgroundColor') ||
          tools.includes('align') ||
          tools.includes('listBullet') ||
          tools.includes('listOrder') ||
          tools.includes('outdent') ||
          tools.includes('indent') ||
          tools.includes('link') ||
          tools.includes('icon') || 
          tools.includes('fontAwesome') ||
          tools.includes('subscript') ||
          tools.includes('superscript')
        ">
          <div class="row -mx-gd-half">
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('bold')"><ToolBold/></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('italic')"><ToolItalic/></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('underline')"><ToolUnderline/></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('color')"><ToolColor /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('backgroundColor')"><ToolBackgroundColor /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('align')"><ToolAlign :value="selectionFormatMerge.align" /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('subscript')"><ToolSubscript /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('superscript')"><ToolSuperscript /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('listBullet')"><ToolListBullet /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('listOrder')"><ToolListOrder /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('outdent')"><ToolOutdent /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('indent')"><ToolIndent /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('link')"><ToolLinking /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('imageIcon')"><ToolImage /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('icon')"><ToolIcon /></div>
            <div class="col-2 px-gd-half mt-gd-half-nth-gt-6" v-if="tools.includes('fontAwesome')"><ToolFontAwesome /></div>
          </div>
        </div>
      </template>

      <template #footer v-if="isCustom">
        <div class="text-right" >
          <a class="fs-sa-14 link-blue cursor-pointer" @click="updateTemplate">{{ 'Update font style' }}</a>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

import ToolTemplate from "./Template";
import ToolFamily from "./Family";
import ToolSize from "./Size";
import ToolLineHeight from "./LineHeight";
import ToolBold from "./Bold";
import ToolItalic from "./Italic";
import ToolUnderline from "./Underline";
import ToolAlign from "./Align";
import ToolColor from "./Color";
import ToolBackgroundColor from "./BackgroundColor";
import ToolListBullet from "./ListBullet";
import ToolListOrder from "./ListOrder";
import ToolOutdent from "./Outdent";
import ToolIndent from "./Indent";
import ToolIcon from "./Icon";
import ToolImage from "./Image";
import ToolLinking from "./Linking";
import ToolFontAwesome from "./FontAwesome";
import ToolSubscript from "./Subscript";
import ToolSuperscript from "./Superscript";

export default {
  components: {
    TitleModal,

    ToolTemplate,
    ToolFamily,
    ToolSize,
    ToolLineHeight,
    ToolBold,
    ToolItalic,
    ToolUnderline,
    ToolAlign,
    ToolColor,
    ToolBackgroundColor,
    ToolListBullet,
    ToolListOrder,
    ToolOutdent,
    ToolIndent,
    ToolIcon,
    ToolImage,
    ToolLinking,
    ToolFontAwesome,
    ToolSubscript,
    ToolSuperscript,
  },
  props: {
    componentID: {
      default: undefined
    },
  },
  data() {
    return {
      pos1: 0,
      pos2: 0,
      pos3: 0,
      pos4: 0,
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
      module: "module",
      siteData: "designIframe/metadata/siteData",
      widgetActive: "designIframe/frame/widgetActive",
      detectDevice: "detectDevice",
      components: "designIframe/metadata/components",
      siteComponents: "designIframe/metadata/siteComponents",
      templateFonts: "designIframe/metadata/templateFonts",
      templateFontsLanguage: "designIframe/metadata/templateFontsLanguage",
    }),
    component() {
      return this.components[this.componentID]
        ? this.components[this.componentID]
        : this.siteComponents[this.componentID];
    },
    tools() {
      return this.texteditor.toolbar.tools;
    },
    selection() {
      return this.texteditor.editor && this.texteditor.editor.getSelection();
    },
    selectionFormat() {
      return this.texteditor.selectionFormat;
    },
    selectionFormatTemplate() {
      return this.texteditor.selectionFormatTemplate;
    },
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    isCustom() {
      return this.texteditor.canUpdateFontTemplate && Boolean(Object.keys(this.customFormats).length);
    },
    customFormats() {
      let customs = {};
      if (this.selectionFormat.family !== undefined) customs.family = this.selectionFormat.family;
      if (this.selectionFormat.size !== undefined) customs.size = this.selectionFormat.size;
      if (this.selectionFormat.color !== undefined) customs.color = this.selectionFormat.color;
      if (this.selectionFormat.bold !== undefined) customs.bold = this.selectionFormat.bold;
      if (this.selectionFormat.italic !== undefined) customs.italic = this.selectionFormat.italic;
      if (Object.prototype.hasOwnProperty.call(this.selectionFormatTemplate, 'decoration')) {
        if (this.selectionFormat.underline !== undefined) customs.underline = this.selectionFormat.underline;
      }
      if (this.selectionFormat.fontWeight !== undefined) customs.fontWeight = this.selectionFormat.fontWeight;
      if (this.selectionFormat.fontStyle !== undefined) customs.fontStyle = this.selectionFormat.fontStyle;
      if (Object.prototype.hasOwnProperty.call(this.selectionFormatTemplate, 'decoration')) {
        if (this.selectionFormat.decoration !== undefined) customs.decoration = this.selectionFormat.decoration;
      }
      return customs;
    },
  },
  mounted () {
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  methods: {
    // Drag Toolbar
    // drag & move https://www.w3schools.com/howto/howto_js_draggable.asp
    dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      document.onmouseup = this.closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = this.elementDrag;
    },
    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      this.pos1 = this.pos3 - e.clientX;
      this.pos2 = this.pos4 - e.clientY;
      this.pos3 = e.clientX;
      this.pos4 = e.clientY;
      // set the element's new position:

      const position = {
        top: this.$refs.tool.offsetTop - this.pos2 + "px",
        left: this.$refs.tool.offsetLeft - this.pos1 + "px",
      };
      this.$store.dispatch("designIframe/texteditor/setToolbar", { position: position });
    },
    closeDragElement() {
      // stop moving when mouse button is released:
      document.onmouseup = null;
      document.onmousemove = null;
    },

    // Format
    formatTemplate(selectionFormat) {
      return selectionFormat.template || selectionFormat.font || selectionFormat.fontOld || this.formatHeaderToTemplate(selectionFormat.header);
    },
    formatHeaderToTemplate(value) {
      if (!value) return 'paragraph1';
      return `heading${value}`;
    },
    formatsToTemplateUpdate(formats) {
      if (Object.prototype.hasOwnProperty.call(formats, 'decoration')) {
        return {
          family: formats.family.split(',')[0].trim().replaceAll('"', ''),
          size: Number(formats.size.replace('px', '')),
          color: this.colorToTpcOrHex(formats.color),
          isBold: (formats.bold || formats.fontWeight == 'bold') ? true : false,
          isItalic: (formats.italic || formats.fontStyle == 'italic') ? true : false,
          isUnderline:( formats.underline || formats.decoration == 'underline') ? true : false,
        };
      } else {
        return {
          family: formats.family.split(',')[0].trim().replaceAll('"', ''),
          size: Number(formats.size.replace('px', '')),
          color: this.colorToTpcOrHex(formats.color),
          isBold: (formats.bold || formats.fontWeight == 'bold') ? true : false,
          isItalic: (formats.italic || formats.fontStyle == 'italic') ? true : false,
        };
      }
    },
    colorToTpcOrHex(value) {
      if (value.includes('--tpc')) { 
        return value.substring(value.indexOf('--'), value.indexOf(')')); // var(--tpc-15) | rgba(var(--tpc-15), 100%) | rgb(var(--tpc-15)) => --tpc-15

      } else if (value.includes('rgba')) { 
        value = value.trim();
        value = value.replaceAll(/^rgba\(/g, '').replaceAll(/\)$/g, ''); // x,x,x,100%
        let arrValue = value.split(',').map(str => str.trim()); // [x,x,x,100%]
        let arrRGB = arrValue.slice(0, 3); // [x,x,x]
        return this.$helper.color.rgbToHex(arrRGB[0], arrRGB[1], arrRGB[2]).toUpperCase(); // #XXXXXX

      } else if (value.includes('rgb')) { 
        value = value.trim();
        value = value.replaceAll(/^rgb\(/g, '').replaceAll(/\)$/g, ''); // x,x,x
        let arrValue = value.split(',').map(str => str.trim()); // [x,x,x]
        let arrRGB = arrValue.slice(0, 3); // [x,x,x]
        return this.$helper.color.rgbToHex(arrRGB[0], arrRGB[1], arrRGB[2]).toUpperCase(); // #XXXXXX

      } else if (value.includes('#')) { 
        return value.toUpperCase();// #xxxxxx => #XXXXXX

      } else {
        return value;
      }
    },

    // Update Template
    updateTemplate() {
      let fontName = this.formatTemplate(this.selectionFormatMerge);
      let fontStyle = this.formatsToTemplateUpdate(this.selectionFormatMerge);

      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: true });
      this.$store.dispatch("designIframe/modals/setModal", {
        modal_id: "modal-fontTemplate-update",
        payload: {
          fontName: fontName,
          fontStyle: fontStyle,
        },
        callback: {
          onSubmit: this.submitUpdateTemplate,
          onClose: this.closeUpdateTemplate,
        }
      });
    },
    submitUpdateTemplate() {
      let fontName = this.formatTemplate(this.selectionFormatMerge);

      // Update Formats
      setTimeout(() => {
        this.clearFormatCustom(fontName);
      }, 100); // wait for update template that effect selectionFormatTemplate, selectionFormatMerge

      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
    },
    closeUpdateTemplate() {
      this.$store.dispatch("designIframe/texteditor/setData", { forceFocus: false });
    },
    clearFormatCustom(value) {
      const selection = this.texteditor.editor.getSelection();
      let formatLine = {
        header: false,
        template: false,
        font: false,
        lineSize: false,
        lineHeight: false,
        lineColor: false,
        lineFontFamily: false,
        listItemColor: false,
        listItemFontFamily: false,
      };
      let formatText = {
        fontOld: false,
        family: false,
        size: false,
        sizeAttribute: false,
        bold: false,
        fontWeight: false,
        italic: false,
        fontStyle: false,
        underline: false,
        decoration: false,
        lineHeight: false,
        color: false,
        background: false,
      };

      if (value == "heading1") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 1; 
        formatLine.template = 'heading1'; 
      } else if (value == "heading2") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 2; 
        formatLine.template = 'heading2'; 
      } else if (value == "heading3") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 3; 
        formatLine.template = 'heading3'; 
      } else if (value == "heading4") { 
        formatLine.header = this.selectionFormatMerge.list ? false : 4; 
        formatLine.template = 'heading4'; 
      } else { 
        formatLine.header = false; // use default
        formatLine.template = value; 
      } 

      // For clear cursor format 
      if (selection.index == 0 && selection.length == 0 && (
        this.selectionFormat.fontOld !== undefined ||
        this.selectionFormat.family !== undefined ||
        this.selectionFormat.size !== undefined ||
        this.selectionFormat.sizeAttribute !== undefined ||
        this.selectionFormat.bold !== undefined ||
        this.selectionFormat.fontWeight !== undefined ||
        this.selectionFormat.italic !== undefined ||
        this.selectionFormat.fontStyle !== undefined ||
        this.selectionFormat.underline !== undefined ||
        this.selectionFormat.decoration !== undefined ||
        this.selectionFormat.lineHeight !== undefined ||
        this.selectionFormat.color !== undefined ||
        this.selectionFormat.background !== undefined
      )) { 
        this.texteditor.editor.setContents([{ insert: '\n' }]);
      }

      // For Current
      this.texteditor.editor.formatLine(selection, formatLine);
      this.texteditor.editor.formatText(selection, formatText);

      // For Last LineBlank
      this.texteditor.editor.formatLine({ index: selection.index + selection.length, length: 0 }, formatLine);
      this.texteditor.editor.formatText({ index: selection.index + selection.length, length: 0 }, formatText);
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        this.closeDragElement()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.mwe-area .mt-gd-half-nth-gt-6:not(:nth-child(1)):not(:nth-child(2)):not(:nth-child(3)):not(:nth-child(4)):not(:nth-child(5)):not(:nth-child(6)) {
  margin-top: 4px !important;
}

.card {
  .list-group {
    padding-bottom: 0.8rem;
    padding-top: 0.8rem;
    &:not(:last-child) {
      border-bottom: 1px solid #dee2e6;
      border-radius: unset;
    }
    .list-group-item {
      border: unset;
      padding: 0.25rem 0.8rem;
    }
  }
}
</style>
